import Vue from 'vue'
import App from './App'
import router from './router'
/* 粘贴复制插件 */
import VueClipboard from 'vue-clipboard2'
/* 内部引用 */
import myUtils from './utils'
import plugins from './components/common'
import store from './store/'
import api from './api/'

import ToastPlugin from 'vux/src/plugins/toast/index.js'
import LoadingPlugin from 'vux/src/plugins/loading/index.js'
import ConfirmPlugin from 'vux/src/plugins/confirm/index.js'
import AlertPlugin from 'vux/src/plugins/alert/index.js'


import './utils/icons'
import filters from './utils/tools/filter'
Vue.config.productionTip = false
global.tools = myUtils.tools
global.myStore = myUtils.myStore
global.browserQuery = myUtils.tools.getAllQueryString()
/* 第三方工具 */
const moment = require('moment')
const JsBarcode = require('jsbarcode')

/* 加载工具 */
Vue.prototype.moment = moment
Vue.prototype.JsBarcode = JsBarcode
Vue.prototype.addon = myUtils.addon
Vue.prototype.api = api
Vue.use(VueClipboard)
/* 加载公共组件 */
Vue.use(plugins)
Vue.use(ToastPlugin)
Vue.use(LoadingPlugin)
Vue.use(ConfirmPlugin)
Vue.use(AlertPlugin)
for (let key in filters) {
Vue.filter(key, filters[key])
}

router.beforeEach((to, from, next) => {
myUtils.addon.handleRouterBeforeEach(to, from, next, store)
})
router.afterEach(route => {
let name = route.name
if (typeof (name) !== 'undefined' && name) {
document.title = name
}
})

/* eslint-disable no-new */
var app = new Vue({
el: '#app',
router,
store,
components: { App },
template: '<App/>'
})
global.app = app
console.log(global.app)



// WEBPACK FOOTER //
// ./src/main.js